export default {
  chats(state) {
    return state.chats;
  },
  lastPage(state) {
    return state.paginations.last_page;
  },
};
